import React from "react";
import { useNavigate } from "react-router-dom";
import { SwimmingPoolRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { validateForm } from "utils/validation";
import fields from "../json/SwimmingPoolFields.json";
import useFetchAllData from "Hooks/useFetchAllData.js";
import { createSwimmingPool, getPoolType } from "adminApi/SwimminPoolApi/SwimminPoolApi";
import AddSwimmingPoolForm from "./components/AddSwimmingPoolForm";

const AddSwimmingPool = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors } = useFormChange(initialValues, SwimmingPoolRules);

    const { data: PoolTypeOptions, loading: loadingPoolType } = useFetchAllData(getPoolType);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await createSwimmingPool({ data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, SwimmingPoolRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Swimming Pool Created Successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingPoolType) && <Spinner isSpinner={true} />}
            <AddSwimmingPoolForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                poolTypeOptions={PoolTypeOptions}
            />
        </>
    );
};

export default AddSwimmingPool;
